import { useState } from "react";
import { Link } from "react-router-dom";
import type { Work } from "@/types/content";

interface WorkCardProps {
  work: Work;
  index?: number;
}

export default function WorkCard({ work, index = 0 }: WorkCardProps) {
  const [hovered, setHovered] = useState(false);

  return (
    <Link
      to={`/works/${work.id}`}
      data-product-shop
      className="group block animate-fade-up rounded-lg border border-background-200 bg-background-50 overflow-hidden cursor-pointer"
      style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-secondary-100">
        <img
          src={work.cover}
          alt={`${work.title} 封面`}
          title={`${work.title} — 天海翼影视作品`}
          className={`w-full h-full object-cover object-top transition-transform duration-500 ${
            hovered ? "scale-105" : "scale-100"
          }`}
        />
        <div
          className={`absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/40 to-transparent transition-opacity duration-300 ${
            hovered ? "opacity-100" : "opacity-0"
          }`}
        />
        <div
          className={`absolute inset-x-0 bottom-0 p-4 transition-all duration-300 ${
            hovered ? "translate-y-0 opacity-100" : "translate-y-3 opacity-0"
          }`}
        >
          <p className="text-xs leading-relaxed text-background-100 clamp-3">{work.summary}</p>
        </div>
        <span className="absolute top-2 left-2 rounded-md bg-accent-500 px-2 py-0.5 text-[11px] font-medium text-background-50 dark:text-foreground-950">
          {work.year}
        </span>
        {work.status !== "已完结" && work.status !== "已上映" && (
          <span className="absolute top-2 right-2 rounded-md bg-primary-500/90 px-2 py-0.5 text-[11px] font-medium text-background-50">
            {work.status}
          </span>
        )}
      </div>
      <div className="p-4">
        <h3 className="font-heading text-base font-semibold text-foreground-950 line-clamp-1 transition-colors group-hover:text-primary-700">
          {work.title}
        </h3>
        <div className="mt-2 flex flex-wrap items-center gap-2">
          <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
            {work.category}
          </span>
          {work.rating > 0 && (
            <span className="flex items-center gap-1 text-[11px] text-accent-700">
              <i className="ri-star-fill" />
              {work.rating.toFixed(1)}
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}